// Restrict this (but keep it const) list to Record<string, SlateBlock['type'] | Omit<keyof SlateLeaf, 'text'>>

import type { SlateTopBlock } from '@atlas/renderer';
import type { MarkName } from './isMarkActive';

const editorFeatures = {
    // Text
    bold: 'bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'strikethrough',
    code: 'code',
    link: 'link',
    // Blocks (paragraph is ignored on purpose as it should be always available no matters what)
    headingOne: 'heading-one',
    headingTwo: 'heading-two',
    headingThree: 'heading-three',
    blockquote: 'block-quote',
    codeBlock: 'code-block',
    callout: 'callout',
    numberedList: 'numbered-list',
    bulletedList: 'bulleted-list',
    table: 'table',
    horizontalLine: 'horizontal-line',
    video: 'video',
    videoEmbed: 'video-embed',
    embed: 'embed',
    image: 'image',
} as const;

export default editorFeatures;

// #region Helpers

export const editorTextFeatures: Readonly<MarkName[]> = [
    editorFeatures.bold,
    editorFeatures.italic,
    editorFeatures.underline,
    editorFeatures.strikethrough,
    editorFeatures.code,
    editorFeatures.link,
];

export const editorBlockFeatures: Readonly<SlateTopBlock['type'][]> = [
    editorFeatures.blockquote,
    editorFeatures.headingOne,
    editorFeatures.headingTwo,
    editorFeatures.headingThree,
    editorFeatures.codeBlock,
    editorFeatures.callout,
    editorFeatures.numberedList,
    editorFeatures.bulletedList,
    editorFeatures.table,
    editorFeatures.horizontalLine,
    editorFeatures.video,
    editorFeatures.videoEmbed,
    editorFeatures.embed,
    editorFeatures.image,
];

// #endregion

// #region Types

export type TEditorFeature = typeof editorFeatures[keyof typeof editorFeatures];

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('EditorFeatures', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
